import { Injector } from "@angular/core";
import { ServiceEnum } from "../../../ServiceEnum";
import { EntityEnum } from "../../EntityEnum";
import { DummyNode } from "../../DummyNode";
import { TreeNodeAbstractPharmaceuticalProductEntity } from "../Entity/TreeNodeAbstractPharmaceuticalProductEntity";
import { BaseNode } from "../../BaseNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";
import { MedicinalproductsService } from "../../../../service/medicinalproducts-service/medicinalproducts.service";
import { OnDemandAutoUploadList } from "./OnDemandAutouploadList";


export class TreeNodeMedicinalProductsAbstractStrengthFormulation extends OnDemandAutoUploadList {
    id: number = 0;
    entity: any;
    useHist: boolean = false;
    constructor(injector: Injector, id: number, entity: EntityEnum, parent: any, useHist: boolean, disableAutoupload: boolean, cloningNode: boolean) {

        var labelTemplate: string = "";
        switch (entity) {
            case EntityEnum.abstractFormulation:
                labelTemplate = "Abstract Formulation";
                break;
            case EntityEnum.abstractStrength:
                labelTemplate = "Abstract Strengths";
                break;
            case EntityEnum.abstractStrengthComposition:
            case EntityEnum.abstractFormulationComposition:
                labelTemplate = "Abstract Composition";
                break;
        }

        super(injector,
            labelTemplate,
            ["Scientific Name", "Scientific Code", "Scientific Strength", "Scientific Pharmaceutical Form Name", "Type", "Is Manually Created", "Was Manually Created", "Part of One Manually Created", "Created (Date/Time)", "Status", "Nullified"],
            ServiceEnum.MedicinalProducts,
            `pk_scientificproduct:eq:${id}`,
            TreeNodeAbstractPharmaceuticalProductEntity,
            entity, disableAutoupload, cloningNode);
        this.parent = parent;
        this.useHist = useHist;
        this.id = id;
        this.entity = entity;
        this.disableAutoUpload = disableAutoupload;
        this.cloningNode = cloningNode;

        switch (entity) {
            case EntityEnum.abstractFormulation:
                this.labelNodeName = "Abstract Formulation";
                break;
            case EntityEnum.abstractStrength:
                this.labelNodeName = "Abstract Strengths";
                break;
            case EntityEnum.abstractStrengthComposition:
            case EntityEnum.abstractFormulationComposition:
                this.labelNodeName = "Abstract Composition";
                break;
        }

        if (this.cloningNode) {
            return;
        }
        this.children?.push(new DummyNode());



    }

    override load() {

        let service: any;
        switch (this.service) {
            case ServiceEnum.MedicinalProducts:
                service = this.ioc!.get(MedicinalproductsService);
                break;
        }

        if (this.isLoaded) {
            return;
        }

        if (this.disableAutoUpload) {
            this.children?.splice(0, this.children.length); // remove dummy node
            this.data = new this.entityClass!(this.ioc!, this.labelTemplate, this, this.disableAutoUpload, this.cloneNode, this.data.model);
            if (!this.cloningNode) {
                this.postLoad(this.dataSource);
            }
            this.isLoaded = true;
        } else {
            this.children?.splice(0, this.children.length); // remove dummy node
            service.getAll(this, this.autoUploadEntityName, this.criteria)
                .subscribe({
                    next: (data: any) => {
                        const jsonData = data.result;
                        const filteredData = this.filterResult(data.result);
                        if (filteredData) {
                            this.dataSource = jsonData;
                            this.postLoad(filteredData);
                            this.isLoaded = true;
                        } else {
                            this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'No results found', life: environment.warningElapsedTime });
                        }
                    },
                    error: (error: any) => {
                        this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Error found', life: environment.errorElapsedTime });
                    }
                });
        }
    }


    override postLoad(model: any[]) {

        for (const item of model) {
            this.children?.push(new this.entityClass!(this.ioc, `${item.scientificname}`, this, false, false, item));
        }
        const numItems: string = model && model.length > 0 ? model.length.toString() : '-';
        this.label = this.labelTemplate + ' (' + numItems + ')';
        this.refreshLabel();
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
        let clonedNode: TreeNodeMedicinalProductsAbstractStrengthFormulation = new TreeNodeMedicinalProductsAbstractStrengthFormulation(
            this.ioc!,
            this.id,
            this.entity,
            newParent,
            false,
            this.isLoaded,
            true
        );

        clonedNode.refreshLabel();
        clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning || environment.userPreferences.alwaysAutoexpandNodes)

        this.children?.forEach((child) => {
            let childToClone = child as BaseNode;
            let clonedChildren = childToClone.cloneNode(clonedNode);
            if (clonedChildren) {
                clonedNode.children?.push(clonedChildren);
                clonedChildren.refreshLabel();
            }
        });

        clonedNode.cloningNode = false;
        return clonedNode;
    }

    override getOnDemandEntities() {
        let entitiesArray:any[] = super.getOnDemandEntities();
        // check if not empy array then set the name for JSON
        if(entitiesArray.length>0) {
            switch (this.entity)
            {
                case EntityEnum.abstractFormulation:
                    return {abstractformulations:{abstractformulation: entitiesArray} }
                case EntityEnum.abstractStrength:
                    return {abstractstrengths:{abstractstrength: entitiesArray} }
                case EntityEnum.abstractStrengthComposition:
                    return {abstractstrengthcompositions:{abstractstrengthcomposition: entitiesArray} }
                case EntityEnum.abstractFormulationComposition:
                    return {abstractformulationcompositions:{abstractformulationcomposition: entitiesArray} }
            }   
            
        }
        return {};
    }

}